// extracted by mini-css-extract-plugin
module.exports = {"title":"SidebarTitle_title__3aB6w","containerTitle":"SidebarTitle_containerTitle__13rDp","separator":"SidebarTitle_separator__1-GtG"};